// extracted by mini-css-extract-plugin
export default {"icon":"icon--eqlqm","icon__svg":"icon__svg--mshmz","iconSvg":"icon__svg--mshmz"};